module.exports = __webpack_public_path__ + "img/notes.0ad10115.svg";